
import { IPSSelectOption } from '@/types/processingSteps'
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import Hint from '../Hint.vue'
import SearchField from './SearchField.vue'
import FieldContainer from './FieldContainer.vue'
@Component({
  components: {
    Hint,
    SearchField,
    FieldContainer
  }
})
export default class SingleSelectField extends Vue {
  @Prop({ default: '' }) value!: string
  @Prop({ default: '' }) error!: string
  @Prop({ default: () => [] }) options!: IPSSelectOption[]
  @Prop({ default: null }) label!: string
  @Prop({ default: false }) required!: boolean
  @Prop({ default: false }) readOnly!: boolean // todo rename all to isReadonly
  @Prop({ default: false }) isDisabled!: boolean
  @Prop({ default: false }) useSearch!: boolean
  @Prop({ default: null }) labelBackgroundColor!: string | null
  @Prop({ default: null }) selectBackgroundColor!: string | null
  @Prop({ default: '' }) hintHtml!: string
  @Prop({ default: '' }) searchLabel!: string
  @Prop({ default: '' }) searchPlaceholder!: string
  @Prop({ default: false }) sortByValue!: boolean

  state: boolean | null = null
  search = ''

  get computedSearchLabel () {
    return this.searchLabel || this.$gettext('Search')
  }

  get computedSearchPlaceholder () {
    return this.searchPlaceholder || this.$gettext('Search')
  }

  get filteredOptions () {
    if (this.sortByValue) {
      return this.options
        .filter(option =>
          option.text.toLowerCase().includes(this.search.toLowerCase())
        )
    }
    return this.options.filter(option =>
      option.text.toLowerCase().includes(this.search.toLowerCase())
    ).sort((a, b) => a.text.localeCompare(b.text))
  }

  get selectedText (): string {
    const selected = this.options.find(option => option.value === this.value)
    return selected ? selected.text : this.$gettext('Please choose')
  }

  clearSearch (): void {
    this.search = ''
  }

  handleSearchChange(value: string) {
    this.search = value
  }

  @Emit('input')
  updateValue(newValue: string) {
    return newValue
  }

  @Watch('error')
  onPropertyChanged(value: string) {
    this.state = value ? false : null
  }
}
